import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { PathName } from 'appConstants';
import { Button } from 'components';

import { mainLaptopImage } from 'assets/images';
import styles from './styles.module.scss';

export const MainContainer = memo(() => {
  const navigate = useNavigate();
  const { t } = useTranslation('welcome');
  const trans = useTranslation('main').t;
  const referralFromURL = window?.location?.search;

  const onClickRegistration = useCallback(() => {
    navigate(`${PathName.Registration}/${referralFromURL}`);
  }, [navigate, referralFromURL]);

  return (
    <div className={styles.main_laptop_container}>
      <div className={styles.main_laptop_container_left}>
        <div className={styles.main_laptop_title}>
          <p className={styles.main_title_second_part}>{t('Title_')}</p>
          <span className={styles.main_title_first_part}>{t('Title_2_')}</span>
        </div>
        <div className={styles.main_subtitle}>
          {t('Subtitle_1')}
        </div>
        <div className={styles.main_subtitle}>
          {t('Subtitle_2')}
        </div>
        <div className={styles.main_subtitle}>
          {t('Subtitle_3')}
        </div>
        <div className={styles.main_subtitle}>
          {t('Subtitle_4')}
        </div>
        <Button
          className={styles.main_btn}
          onClick={onClickRegistration}
          color="blue"
        >
          {trans('Register_')}
        </Button>
      </div>
      <div className={styles.main_laptop_container_right}>
        <img
          alt=""
          src={mainLaptopImage}
          loading="lazy"
        />
      </div>
    </div>
  );
});
